(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["total-money-display"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.money, .Vtl-Money';
  const pattern = /(-?\d[\d,\u00a0\u202f ]*(?:\.\d+)?)\s*(?:TND|DT)\b/g;
  const compact = text => text.replace(pattern, (_, amount) => {
    let value = amount.trim();
    if (value.includes('.')) value = value.replace(/0+$/, '').replace(/\.$/, '');
    return `${value} DT`;
  });
  function format(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const value = compact(node.nodeValue);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }
  function scan(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches(selector)) format(root);
    root.querySelectorAll(selector).forEach(format);
  }
  function start() {
    scan(document.body);
    const pending = new Set();
    let frame = 0;
    new MutationObserver(records => {
      records.forEach(record => {
        const element = record.target.nodeType === Node.TEXT_NODE ? record.target.parentElement : record.target;
        const price = element.closest?.(selector);
        if (price) pending.add(price);
        record.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) pending.add(node);
        });
      });
      if (frame || !pending.size) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        pending.forEach(node => { if (node.isConnected) scan(node); });
        pending.clear();
      });
    }).observe(document.body, {childList: true, characterData: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
